(() => {
  if (window.HK360RecipeDeliveryProgress?.refresh) {
    window.HK360RecipeDeliveryProgress.refresh();
    return;
  }
  let version = 0;
  const euro = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  const root = window.Shopify?.routes?.root || '/';
  const refresh = async () => {
    const node = document.querySelector('[data-hk196-delivery]');
    if (!node) return;
    const status = node.querySelector('[data-hk196-status]');
    const progress = node.querySelector('[data-hk196-progress]');
    if (!status || !progress) return;
    const current = ++version;
    status.dataset.state = 'loading';
    status.textContent = 'Je winkelwagen controleren…';
    try {
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw Error('Cart unavailable');
      const cart = await response.json();
      if (current !== version || !node.isConnected) return;
      if (cart.currency && cart.currency !== 'EUR') {
        progress.hidden = true;
        status.dataset.state = 'unavailable';
        status.textContent = 'Deze bezorgindicatie geldt voor bestellingen in euro. Controleer je winkelwagen.';
        return;
      }
      const cents = Number(cart.total_price);
      const minimum = Number(node.dataset.min);
      const free = Number(node.dataset.free);
      if (!Number.isSafeInteger(cents) || cents < 0 || !Number.isSafeInteger(minimum) ||
          !Number.isSafeInteger(free) || minimum <= 0 || free <= minimum) throw Error('Invalid amount');
      progress.hidden = false;
      progress.max = free;
      progress.value = Math.min(cents, free);
      progress.setAttribute('aria-valuetext', euro.format(cents / 100) + ' van ' + euro.format(free / 100));
      status.dataset.state = cents >= free ? 'complete' : 'incomplete';
      if (cents >= free) status.textContent = 'Je winkelwagen bereikt de grens voor gratis lokale bezorging.';
      else if (cents >= minimum) status.textContent = 'Nog ' + euro.format((free - cents) / 100) + ' tot gratis lokale bezorging.';
      else status.textContent = 'Nog ' + euro.format((minimum - cents) / 100) + ' tot het minimum voor lokale bezorging.';
    } catch (_) {
      if (current !== version || !node.isConnected) return;
      progress.hidden = true;
      status.dataset.state = 'unavailable';
      status.textContent = 'De bezorgindicatie is tijdelijk niet beschikbaar. Bekijk je winkelwagen.';
    }
  };
  window.HK360RecipeDeliveryProgress = { refresh };
  window.addEventListener('hk360:cart-changed', refresh);
  window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();